import React from "react";
import { Link } from "react-router-dom";
import { ArrowDown, Sparkles } from "lucide-react";

const Hero = () => {
  const scrollDown = () => {
    window.scrollTo({ top: window.innerHeight - 80, behavior: "smooth" });
  };

  return (
    <section
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{ backgroundColor: "#0a2e1f" }}
    >
      {/* Ambient gradient blobs */}
      <div
        className="absolute -top-40 -left-40 w-[500px] h-[500px] rounded-full blur-3xl opacity-30"
        style={{
          background:
            "radial-gradient(circle, #10b981 0%, transparent 70%)",
        }}
      />
      <div
        className="absolute -bottom-40 -right-40 w-[600px] h-[600px] rounded-full blur-3xl opacity-25"
        style={{
          background:
            "radial-gradient(circle, #34d399 0%, transparent 70%)",
        }}
      />

      {/* Subtle grid overlay */}
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
      />

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center pt-20">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 mb-8 px-4 py-1.5 rounded-full border border-emerald-400/30 bg-emerald-500/10 backdrop-blur-sm">
          <Sparkles size={14} className="text-emerald-300" />
          <span className="text-emerald-100 text-xs font-medium tracking-[0.25em] uppercase">
            For Over 25 Years
          </span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.05] mb-8 tracking-tight">
          The Electronic Wire & <br className="hidden md:block" />
          <span
            className="bg-clip-text text-transparent"
            style={{
              backgroundImage:
                "linear-gradient(135deg, #6ee7b7 0%, #10b981 50%, #34d399 100%)",
            }}
          >
            Cable Specialists
          </span>
        </h1>

        <p className="text-base md:text-lg text-slate-300 font-light max-w-2xl mx-auto mb-12 leading-relaxed">
          Licensed building contractor, cable specialist and custom engineering —
          design, wire and install across Hawaii with craftsmanship you can trust.
        </p>

        {/* CTA Row */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <a
            href="#services"
            className="px-8 py-3.5 rounded-full text-white text-sm font-semibold shadow-xl shadow-emerald-500/30 hover:shadow-emerald-500/50 hover:scale-[1.03] transition-all"
            style={{
              background:
                "linear-gradient(135deg, #10b981 0%, #059669 100%)",
            }}
            onClick={(e) => {
              e.preventDefault();
              scrollDown();
            }}
          >
            Explore Services
          </a>
          <Link
            to="/contact"
            className="px-8 py-3.5 rounded-full text-white text-sm font-semibold border border-white/20 hover:bg-white/10 backdrop-blur-sm transition-colors"
          >
            Get a Quote
          </Link>
        </div>

        <button
          onClick={scrollDown}
          className="group inline-flex items-center justify-center w-12 h-12 rounded-full border border-white/20 hover:border-emerald-400 hover:bg-emerald-500/10 transition-all duration-300"
          aria-label="Scroll down"
        >
          <ArrowDown
            className="text-white/70 group-hover:text-emerald-300 transition-colors animate-bounce"
            size={18}
          />
        </button>
      </div>
    </section>
  );
};

export default Hero;
